import { Violation, ViolationSeverity } from './../violation';
import { getPropertyRulesFor, updatePropertyRulesFor } from './utils';

export class PatternError extends Violation {
    public constructor(message: string) {
        super(ViolationSeverity.Error, message);
    }
}

export function Pattern(args: { pattern: RegExp }, message: string): PropertyDecorator {
    return (target: Object, propertyKey: string | symbol): void => {
        const key = propertyKey as string;
        const propertyRules = getPropertyRulesFor(target, key);

        propertyRules.push([{
            async: false,
            violationType: PatternError.bind(null, message),
            validate: (context, { pattern = new RegExp('')  }) => {
                const value = context.source[key];
                if (!value) return true;
                return pattern.test(value);
            }
        }, args]);

        updatePropertyRulesFor(target, key, propertyRules);
    };
}
